module.exports = __webpack_public_path__ + "static/media/wednesday.4d575c5d.ogg";